import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import { verificarRol, gestionLegajos } from "../../constans/constants";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import TablaItemsConfiguracion from "../componentes/tablas/TablaItemsConfiguracion";
import {
  getColaboradores,
  importarCsv,
  descargarPlantilla,
} from "./VacacionesService";

class Vacaciones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalCsvAbierto: false,
      archivoCsv: null,
      erroresCsv: [],
      cargando: false,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      mensajeFlashSeverity: "neutral",
    };

    this.tablaRef = React.createRef();
    this.dialogCsvRef = React.createRef();

    const navState = props?.location?.state;
    if (navState?.mostrarMensajeFlash) {
      this.state.mostrarMensajeFlash = true;
      this.state.mensajeFlash = navState.mensajeFlash || "";
      this.state.mensajeFlashSeverity = navState.mensajeFlashSeverity || "neutral";
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.modalCsvAbierto && !prevState.modalCsvAbierto) {
      this.dialogCsvRef.current?.showModal();
    } else if (!this.state.modalCsvAbierto && prevState.modalCsvAbierto) {
      if (this.dialogCsvRef.current?.open) this.dialogCsvRef.current.close();
    }
  }

  fetchColaboradores = (page, pageSize, search) => {
    return getColaboradores(page, pageSize, search).then((res) => {
      const data = res.data;
      return {
        items: data.page?.content || [],
        totalCount: data.page?.totalElements || 0,
      };
    });
  };

  actualizarTabla = () => {
    if (this.tablaRef.current) this.tablaRef.current.fetchData();
  };

  verMovimientos = (colaborador) => {
    this.props.history.push({
      pathname: `/administracion/vacaciones/legajo/${colaborador.legajoId}`,
      state: {
        legajoId: colaborador.legajoId,
        nombreColaborador: colaborador.nombreApellido,
      },
    });
  };

  // ======================
  // Modal CSV
  // ======================
  abrirCsv = () => this.setState({ modalCsvAbierto: true, archivoCsv: null, erroresCsv: [] });
  cerrarCsv = () => this.setState({ modalCsvAbierto: false, archivoCsv: null, erroresCsv: [] });

  handleCsv = (e) => this.setState({ archivoCsv: e.target.files[0] || null });

  subirCsv = async () => {
    const { archivoCsv } = this.state;
    if (!archivoCsv) {
      this.flash("Seleccione un archivo CSV", "error");
      return;
    }
    this.setState({ cargando: true });
    try {
      const res = await importarCsv(archivoCsv);
      const errores = res.data?.datos || [];
      this.setState({ cargando: false, erroresCsv: errores });
      this.flash(res.data?.mensaje || "Importación completada", errores.length > 0 ? "error" : "exito");
      if (errores.length === 0) {
        this.setState({ modalCsvAbierto: false });
        this.actualizarTabla();
      }
    } catch (e) {
      this.setState({ cargando: false });
      this.flash(e?.response?.data?.mensaje || "Error al importar", "error");
    }
  };

  flash = (mensaje, severity) =>
    this.setState({ mostrarMensajeFlash: true, mensajeFlash: mensaje, mensajeFlashSeverity: severity });

  renderFilas = (filas) =>
    filas.map((f) => (
      <tr key={f.legajoId}>
        <td>{f.nombreApellido || "--"}</td>
        <td>{f.cedula || "--"}</td>
        <td>
          <span className={`badge-estado ${f.saldo > 0 ? "badge-activo" : "badge-neutro"}`}>
            {f.saldo} días
          </span>
        </td>
        <td>
          <div className="table-actions">
            <button
              className="table-icon"
              title="Ver movimientos"
              onClick={() => this.verMovimientos(f)}
            >
              <span className="material-symbols-outlined">visibility</span>
            </button>
          </div>
        </td>
      </tr>
    ));

  renderModalCsv = () => {
    const { erroresCsv, cargando } = this.state;

    return (
      <div className="component-modal">
        <dialog className="modal" ref={this.dialogCsvRef} onClose={this.cerrarCsv}>
          <div className="modal-content">
            <div className="modal-head">
              <h4 className="modal-title">Carga masiva de vacaciones (CSV)</h4>
              <div className="actions">
                <button className="btn-medium btn-circle-icon btn-primary-tonal" onClick={this.cerrarCsv}>
                  <span className="material-symbols-outlined">close</span>
                </button>
              </div>
            </div>

            <div className="modal-body">
              <p className="page-description">
                El archivo CSV debe contener las columnas: <strong>ci, dias, observaciones</strong>
              </p>

              <button className="btn-medium btn-base-outline mb-2" onClick={descargarPlantilla}>
                <span className="material-symbols-outlined">download</span>
                Descargar plantilla
              </button>

              <div className="form-group">
                <input
                  className="form-input inputFile"
                  type="file"
                  accept=".csv"
                  onChange={this.handleCsv}
                />
              </div>

              {erroresCsv.length > 0 && (
                <div className="errores-csv">
                  <p className="txt-error"><strong>Errores encontrados:</strong></p>
                  <ul>
                    {erroresCsv.map((e, i) => <li key={i}>{e}</li>)}
                  </ul>
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button className="btn-medium btn-base-outline" onClick={this.cerrarCsv}>
                Cancelar
              </button>
              <button className="btn-medium btn-primary" onClick={this.subirCsv} disabled={cargando}>
                {cargando ? "Importando..." : "Importar"}
              </button>
            </div>
          </div>
        </dialog>
      </div>
    );
  };

  render() {
    const { mostrarMensajeFlash, mensajeFlash, mensajeFlashSeverity } = this.state;

    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl="/administracion/legajos"
                breadcrumbs={[{ label: "Administración", path: "/administracion/legajos" }]}
              />

              <nav className="nav-area">
                <NavLink to="/administracion/usuarios" className="nav-link">
                  <span className="material-symbols-outlined">account_circle</span>
                  Usuarios
                </NavLink>
                <NavLink to="/administracion/grupos" className="nav-link">
                  <span className="material-symbols-outlined">supervised_user_circle</span>
                  Grupos de usuarios
                </NavLink>
                {verificarRol(JSON.parse(localStorage.getItem("roles")), [gestionLegajos]) && <NavLink to="/administracion/legajos" className="nav-link">
                  <span className="material-symbols-outlined">assignment_ind</span>
                  Legajos
                </NavLink>}
                {verificarRol(JSON.parse(localStorage.getItem("roles")), [gestionLegajos]) && <NavLink to="/administracion/vacaciones" className="nav-link">
                  <span className="material-symbols-outlined">beach_access</span>
                  Vacaciones
                </NavLink>}
              </nav>

              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title">Gestión de vacaciones</h1>
                  <p className="page-description">
                    Seleccione un colaborador para ver sus movimientos y gestionar sus vacaciones
                  </p>
                </div>

                <div className="head-actions">
                  <button className="btn-medium btn-base-outline" onClick={this.abrirCsv}>
                    <span className="material-symbols-outlined">upload_file</span>
                    Carga masiva CSV
                  </button>
                </div>
              </div>
            </div>
          </header>

          <div className="wrapperContent">
            <div className="page-container">
              <TablaItemsConfiguracion
                ref={this.tablaRef}
                titulo="Colaboradores"
                headers={["Colaborador", "Cédula", "Saldo disponible", "Acciones"]}
                fetchDatos={this.fetchColaboradores}
                renderFilas={this.renderFilas}
              />
            </div>
          </div>
        </div>

        {this.renderModalCsv()}

        <MensajeFlash
          visible={mostrarMensajeFlash}
          mensaje={mensajeFlash}
          severity={mensajeFlashSeverity}
        />
        <PantallaCarga mensaje="Procesando..." />
      </div>
    );
  }
}

export default connect(null, null)(Vacaciones);
